export type RuntimeEnvironments = ReturnType<() => 'staging' | 'production'>;

export default function getRuntimeEnvironment(): RuntimeEnvironments {
  if (typeof window !== 'undefined') {
    if (
      ['www.iwoca.co.uk', 'www.iwoca.de'].includes(window.location.hostname)
    ) {
      return 'production';
    }
  }

  return 'staging';
}
